module.exports = __webpack_public_path__ + "static/media/screenshot-view-taste.9b9d4059.png";